import * as history from 'history';

export const mainRouterHistory =  history.createBrowserHistory();